var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SpFinder',{ref:"finder",attrs:{"url":{
    data: 'https://ecboot.it.shopex123.com/finder/data/list?finderId=1'
  },"title":"数据","columns":_vm.columns,"actions":_vm.actions}})
}
var staticRenderFns = []

export { render, staticRenderFns }